import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AppRoutingModule} from "../../app-routing.module";
import {ProfileComponent} from "./profile/profile.component";
import {EventManagementComponent} from "./profile/event-management/event-management.component";
import {UserRoutingModule} from "./user-routing.module";
import {FieldsetModule} from "primeng/fieldset";
import {BreadcrumbModule} from "primeng/breadcrumb";
import {ButtonModule} from "primeng/button";
import {InputTextModule} from "primeng/inputtext";
import {ReactiveFormsModule} from "@angular/forms";
import {SharedModule} from "../../shared/shared.module";
import {EditProfileComponent} from './profile/edit-profile/edit-profile.component';
import {EditPasswordComponent} from './profile/edit-password/edit-password.component';
import {ToastModule} from "primeng/toast";
import {UserEventComponent} from './user-event/user-event.component';
import {EventContactComponent} from './event-contact/event-contact.component';
import {TabsModule} from "primeng/tabs";
import {TableModule} from "primeng/table";
import {PaginatorModule} from "primeng/paginator";
import {AddPhoneNumberComponent} from './profile/add-phone-number/add-phone-number.component';
import {RemoveAllEventsModalComponent} from './profile/modal/remove-all-events-modal/remove-all-events-modal.component';
import {
  TransferAllEventsModalComponent
} from './profile/modal/transfer-all-events-modal/transfer-all-events-modal.component';
import {MenuModule} from "primeng/menu";


@NgModule({
    declarations: [
        ProfileComponent,
        EventManagementComponent,
        EditProfileComponent,
        EditPasswordComponent,
        UserEventComponent,
        EventContactComponent,
        AddPhoneNumberComponent,
        RemoveAllEventsModalComponent,
        TransferAllEventsModalComponent
    ],
    exports: [
        AddPhoneNumberComponent
    ],
    imports: [
        CommonModule,
        AppRoutingModule,
        UserRoutingModule,
        FieldsetModule,
        BreadcrumbModule,
        ButtonModule,
        InputTextModule,
        ReactiveFormsModule,
        SharedModule,
        ToastModule,
        TabsModule,
        TableModule,
        MenuModule,
        PaginatorModule
    ]
})
export class UserModule {
}
